// extracted by mini-css-extract-plugin
module.exports = {"embed":"embed--1P5vS","empty":"empty--3Xj5V"};